import React from 'react';

export default function Checkbox() {
  return (
    <React.Fragment>
      It's a Checkbox!
    </React.Fragment>
  );
}
